import { render, staticRenderFns } from "./addcloudscene.vue?vue&type=template&id=e1261b68&scoped=true&"
import script from "./addcloudscene.vue?vue&type=script&lang=js&"
export * from "./addcloudscene.vue?vue&type=script&lang=js&"
import style0 from "./addcloudscene.vue?vue&type=style&index=0&id=e1261b68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1261b68",
  null
  
)

export default component.exports